// eslint-disable-next-line no-restricted-imports
import { useDirectoryGetRecordQuery } from 'api/generated/graphql';
import { parseDirectoryRecordData, useError } from 'api/helpers';

export const useDirectoryGetRecord = (id: string) => {
  const {
    loading,
    error: apolloError,
    data,
  } = useDirectoryGetRecordQuery({
    variables: {
      id,
    },
  });

  const error = useError(apolloError);

  const record = data?.directoryRecord
    ? parseDirectoryRecordData(data.directoryRecord)
    : undefined;

  return {
    record,
    loading,
    error,
  };
};
